var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTrashCanFeedbackError = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M31.475 16.889a1.366 1.366 0 0 1 1.167-1.54L44.65 13.66a1.366 1.366 0 0 1 1.546 1.159l.65 4.632a.43.43 0 0 1-.365.483l-13.87 1.95a.43.43 0 0 1-.486-.364l-.65-4.632Zm37.59 56.245a1.658 1.658 0 0 1-1.416 1.87l-40.2 5.649a1.665 1.665 0 0 1-1.883-1.412l-6.217-44.237a.43.43 0 0 1 .366-.483l42.64-5.993a.43.43 0 0 1 .486.364l6.217 44.243.006-.001ZM65.252 28.12l-48.436 6.807a.43.43 0 0 1-.485-.363l-1.087-7.737a2.484 2.484 0 0 1 2.121-2.8l43.93-6.175a2.92 2.92 0 0 1 3.302 2.477l1.027 7.307a.43.43 0 0 1-.372.484Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M34.187 18.32a1.366 1.366 0 0 1 1.167-1.54l10.233-1.448a1.366 1.366 0 0 1 1.545 1.16l.468 3.237a.43.43 0 0 1-.366.483l-12.38 2.527s-.166-.948-.2-1.181l-.467-3.238Zm34.57 54.156a1.658 1.658 0 0 1-1.416 1.87l-35.624 4.98a1.665 1.665 0 0 1-1.884-1.413L23.775 37.48a.43.43 0 0 1 .366-.483l38.367-5.764a.43.43 0 0 1 .485.363l5.758 40.882h.006ZM64.822 28.13l-43.81 6.836a.43.43 0 0 1-.485-.364l-1.087-7.736a2.484 2.484 0 0 1 2.12-2.801l38.283-6.04c1.597-.224 4.434-.372 4.835 2.477l1.13 6.345c.034.233-.746 1.25-.986 1.283Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M31.475 16.889a1.366 1.366 0 0 1 1.167-1.54L44.65 13.66a1.366 1.366 0 0 1 1.546 1.159l.65 4.632a.43.43 0 0 1-.365.483l-13.87 1.95a.43.43 0 0 1-.486-.364l-.65-4.632Zm37.59 56.245a1.658 1.658 0 0 1-1.416 1.87l-40.2 5.649a1.665 1.665 0 0 1-1.883-1.412l-6.217-44.237a.43.43 0 0 1 .366-.483l42.64-5.993a.43.43 0 0 1 .486.364l6.217 44.243.006-.001ZM65.252 28.12l-48.436 6.807a.43.43 0 0 1-.485-.363l-1.087-7.737a2.484 2.484 0 0 1 2.121-2.8l43.93-6.175a2.92 2.92 0 0 1 3.302 2.477l1.027 7.307a.43.43 0 0 1-.372.484Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-90)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m29.605 39.977 4.998 34.57M41.267 38.312l4.998 34.569M52.929 38.312l4.998 34.569"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m30.438 38.312 4.998 34.569M42.1 36.646l4.998 34.569M53.762 36.646l4.998 34.569"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M67.178 82a13.43 13.43 0 0 0 13.489-13.787C80.5 60.6 74.19 54.426 66.575 54.426a13.43 13.43 0 0 0-13.489 13.787C53.253 75.828 59.562 82 67.178 82Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M61.838 63.444a1.13 1.13 0 0 1 1.63 0l7.174 7.379a1.21 1.21 0 0 1 0 1.677 1.13 1.13 0 0 1-1.63 0l-7.174-7.379a1.21 1.21 0 0 1 0-1.677Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M62.165 72.5a1.21 1.21 0 0 1 0-1.677l7.173-7.378a1.13 1.13 0 0 1 1.631 0 1.21 1.21 0 0 1 0 1.677L63.795 72.5a1.13 1.13 0 0 1-1.63 0Z",
    clipRule: "evenodd"
  }));
};
export default SvgTrashCanFeedbackError;